module.exports = __webpack_public_path__ + "img/new_unactive_07.ca9934cd.jpg";